import React from 'react';
import Autocomplete from 'react-toolbox/lib/autocomplete';
import Button from 'react-toolbox/lib/button';
import Input from 'react-toolbox/lib/input';// to use input from react-toolbox library
import Error from 'components/ErrorMessage';// to display error messages on invalid user input
import { regExForName, regExForNumber } from 'constants/Regularexpression'; // regular expressions to validate user input
import PropTypes from 'prop-types'; // to validate and set default props  coming to this component
import renderIf from 'render-if';// to use conditional rendering based on values that is provided to component
import { is, Map } from 'immutable'; // use of immutablejs for various js operations to simplify our work
import cn from 'classnames'; // to use global class name eg. classes from grid.css in public folder
import styles from './PersonalInfo.scss';// to import local scss fle
import theme from './theme.css';

const emptyObject = {};

const state = {
  AL: 'Alabama',
  AK: 'Alaska',
  AZ: 'Arizona',
  AR: 'Arkansas',
  CA: 'California',
  CO: 'Colorado',
  CT: 'Connecticut',
  DE: 'Delaware',
  FL: 'Florida',
  GA: 'Georgia',
  HI: 'Hawaii',
  ID: 'Idaho',
  IL: 'Illinois',
  IN: 'Indiana',
  IA: 'Iowa',
  KS: 'Kansas',
  KY: 'Kentucky',
  LA: 'Louisiana',
  ME: 'Maine',
  MD: 'Maryland',
  MA: 'Massachusetts',
  MI: 'Michigan',
  MN: 'Minnesota',
  MS: 'Mississippi',
  MO: 'Missouri',
  MT: 'Montana',
  NE: 'Nebraska',
  NV: 'Nevada',
  NH: 'New Hampshire',
  NJ: 'New Jersey',
  NM: 'New Mexico',
  NY: 'New York',
  NC: 'North Carolina',
  ND: 'North Dakota',
  OH: 'Ohio',
  OK: 'Oklahoma',
  OR: 'Oregon',
  PA: 'Pennsylvania',
  RI: 'Rhode Island',
  SC: 'South Carolina',
  SD: 'South Dakota',
  TN: 'Tennessee',
  TX: 'Texas',
  UT: 'Utah',
  VT: 'Vermont',
  VA: 'Virginia',
  WA: 'Washington D.C',
  WN: 'Washington',
  WV: 'West Virginia',
  WI: 'Wisconsin',
  WY: 'Wyoming',
};


class PersonalInfo extends React.Component {

  static propTypes = {
    next: PropTypes.func.isRequired,
    show: PropTypes.bool.isRequired,
    profile: PropTypes.instanceOf(Map),
    attributes: PropTypes.shape(),
  };
  static defaultProps = {
    next: () => {},
    show: true,
    profile: Map(),
    attributes: () => {},
  };


  constructor(props) {
    super(props);
    this.state = {
      gender: 'male',
      fullname: '',
      state: '',
      city: '',
      mobile: '',
      twitter: '',
      instagram: '',
      firstNameErrorMessage: '',
      lastNameErrorMessage: '',
      stateErrorMessage: '',
      mobileErrorMessage: '',
      cityErrorMessage: '',
      twitterErrorMessage: '',
      instagramErrorMessage: '',
    };
    this.handleChange = this.handleChange.bind(this);
    this.goToNextTab = this.goToNextTab.bind(this);
    this.removeErrorMessage = this.removeErrorMessage.bind(this);
    this.handleQueryChange = this.handleQueryChange.bind(this);
  }

  componentWillMount() {
    window.scrollTo(0, 0);
    if (this.props.attributes.size > 0) {
      const fullName = this.props.attributes.get('name');
      const parts = fullName.split(' ');
      const firstName = parts.shift();
      const lastnamefirst = parts.shift() || '';
      const lastNamesecond = parts.shift() || '';
      const lastName = `${lastnamefirst} ${lastNamesecond}`;
      this.setState({ firstName, lastName });
    }
  }

  componentWillReceiveProps(nextProps) {
    if (!is(nextProps.attributes, this.props.attributes) && nextProps.attributes.size > 0) {
      const fullName = nextProps.attributes.get('name');
      const parts = fullName.split(' ');
      const firstName = parts.shift();
      const lastnamefirst = parts.shift() || '';
      const lastNamesecond = parts.shift() || '';
      const lastName = `${lastnamefirst} ${lastNamesecond}`;
      this.setState({ firstName, lastName });
    }

    const { profile = Map() } = this.props;
    if (nextProps.profile.size > 0 && !is(profile, nextProps.profile)) {
      const newState = {
        gender: nextProps.profile.get('gender'),
        firstName: nextProps.profile.get('firstName'),
        lastName: nextProps.profile.get('lastName'),
        state: nextProps.profile.get('sa_state'),
        city: nextProps.profile.get('city'),
      };
      this.setState(newState);
    }
  }

  handleChange = (name, value) => {
    this.setState({ ...this.state, [name]: value });
  };

  removeErrorMessage = (name) => {
    this.setState({ ...this.state, [name]: '' });
  };

  goToNextTab() {
    const { firstName, lastName, city } = this.state;

    let validState = false;
    let validCity = false;
    let validFirstName = false;
    let ValidLastName = false;
    let validMobile = false;
    // const validTwitter = false;
    // const validInstagram = false;
    /* validation for Full Name */
    const enteredFirstName = typeof firstName === 'string';
    if (enteredFirstName && firstName !== '') {
      validFirstName = true;
    } else {
      this.setState({ firstNameErrorMessage: 'Please enter a valid name.' });
    }
    /* validation for Full Name */

      /* validation for Full Name */
    const enteredLastName = typeof lastName === 'string';
    if (enteredLastName && lastName !== '') {
      ValidLastName = true;
    } else {
      this.setState({ lastNameErrorMessage: 'Please enter a valid name.' });
    }
      /* validation for Full Name */

    /* validation for city */
    const enteredCity = regExForName.test(city);
    if (enteredCity && city !== '') {
      validCity = true;
    } else {
      this.setState({ cityErrorMessage: 'Please enter a valid city.' });
    }
    /* validation for city */

    /* validation for state */
    const enteredState = (typeof this.state.state === 'string');
    if (enteredState && this.state.state !== '') {
      validState = true;
    } else {
      this.setState({ stateErrorMessage: 'Please enter a valid state.' });
    }
    /* validation for state */

    /* Validation for mobile */
    const enteredMobile = regExForNumber.test(this.state.mobile);
    if (enteredMobile && this.state.mobile !== '') {
      validMobile = true;
    } else {
      this.setState({ mobileErrorMessage: 'Please enter a valid mobile number.' });
    }
    /* Validation for mobile */

    // const enteredTwitter = 'twitter.com';
    // if (this.state.twitter === '') {
    //   validTwitter = true;
    // } else if (this.state.twitter.indexOf(enteredTwitter) === -1) {
    //   this.setState({ twitterErrorMessage: 'Please enter a valid twitter link.' });
    // } else {
    //   validTwitter = true;
    // }
    //   /* Validation for mobile */
    // const enteredInstagram = 'instagram.com';
    // if (this.state.instagram === '') {
    //   validInstagram = true;
    // } else if (this.state.instagram.indexOf(enteredInstagram) === -1) {
    //   this.setState({ instagramErrorMessage: 'Please enter a valid instagram link.' });
    // } else {
    //   validInstagram = true;
    // }
      /* Validation for mobile */

    if (validFirstName && ValidLastName && validCity && validState && validMobile) {
      this.props.next(this.state);
    }
  }
  handleQueryChange(val) {
    this.handleChange('state', val);
  }
  render() {
    const { firstNameErrorMessage, lastNameErrorMessage, stateErrorMessage, instagramErrorMessage,
        cityErrorMessage, mobileErrorMessage, twitterErrorMessage } = this.state;
    const renderIfShow = renderIf(this.props.show);
    return (
      <div>
        {renderIfShow(
          <div className={cn('row', styles.personalInfoContainer)}>
            <div className={cn('col s12', styles.fullWidth)}>
              <div className={firstNameErrorMessage === '' ? cn('col s12 m6', styles.halfWidthWithSpan) : cn('col s12 m6', styles.halfWidthWithSpanError)}>
                <span>FIRST NAME</span>
                <Input
                  type="text"
                  name="full_name"
                  value={this.state.firstName}
                  onFocus={() => this.removeErrorMessage('firstNameErrorMessage')}
                  onChange={val => this.handleChange('firstName', val)}
                />
                <Error message={this.state.firstNameErrorMessage} />
              </div>
              <div className={lastNameErrorMessage === '' ? cn('col s12 m6', styles.halfWidthWithSpan) : cn('col s12 m6', styles.halfWidthWithSpanError)}>
                <span>LAST NAME</span>
                <Input
                  type="text"
                  name="full_name"
                  value={this.state.lastName}
                  onFocus={() => this.removeErrorMessage('lastNameErrorMessage')}
                  onChange={val => this.handleChange('lastName', val)}
                />
                <Error message={this.state.lastNameErrorMessage} />
              </div>
            </div>
            <div className={cn('col s12', styles.fullWidth)}>
              <div className={stateErrorMessage === '' ? cn('col s12 m6', styles.halfWidthAutoComplete) : cn('col s12 m6', styles.halfWidthAutoCompleteError)}>
                <span>STATE</span>
                <Autocomplete
                  onChange={val => this.handleChange('state', val)}
                  onQueryChange={val => this.handleQueryChange(val)}
                  source={this.state.state === '' ? emptyObject : state}
                  value={this.state.state}
                  multiple={false}
                  onFocus={() => this.removeErrorMessage('stateErrorMessage')}
                  theme={theme}
                />
                <Error message={stateErrorMessage} />
              </div>
              <div className={cityErrorMessage === '' ? cn('col s12 m6', styles.halfWidthAutoComplete) : cn('col s12 m6', styles.halfWidthAutoCompleteError)}>
                <span>CITY</span>
                <Input
                  type="text"
                  name="city"
                  value={this.state.city}
                  onChange={val => this.handleChange('city', val)}
                  onFocus={() => this.removeErrorMessage('cityErrorMessage')}
                />
                <Error message={cityErrorMessage} />
              </div>
              <div className={mobileErrorMessage === '' ? cn('col s12 m6', styles.halfWidthAutoComplete) : cn('col s12 m6', styles.halfWidthAutoCompleteError)}>
                <span>PHONE</span>
                <Input
                  type="text"
                  name="mobile"
                  value={this.state.mobile}
                  onChange={val => this.handleChange('mobile', val)}
                  onFocus={() => this.removeErrorMessage('mobileErrorMessage')}
                />
                <Error message={mobileErrorMessage} />
              </div>
              <div className={twitterErrorMessage === '' ? cn('col s12 m6', styles.halfWidthAutoComplete) : cn('col s12 m6', styles.halfWidthAutoCompleteError)}>
                <span>TWITTER HANDLE (OR)  URL
                <span className={styles.optionalTag}>&nbsp;&nbsp;(Optional)</span>
                </span>
                <Input
                  type="text"
                  name="twitter"
                  value={this.state.twitter}
                  onChange={val => this.handleChange('twitter', val)}
                  onFocus={() => this.removeErrorMessage('twitterErrorMessage')}
                />
                <Error message={twitterErrorMessage} />
              </div>
              <div className={instagramErrorMessage === '' ? cn('col s12 m6', styles.halfWidthAutoComplete) : cn('col s12 m6', styles.halfWidthAutoCompleteError)}>
                <span>INSTAGRAM HANDLE  (OR) URL
                  <span className={styles.optionalTag}>&nbsp;&nbsp;(Optional)</span>
                </span>
                <Input
                  type="text"
                  name="instagram"
                  value={this.state.instagram}
                  onChange={val => this.handleChange('instagram', val)}
                  onFocus={() => this.removeErrorMessage('instagramErrorMessage')}
                />
                <Error message={instagramErrorMessage} />
              </div>
            </div>
            <div className={cn('col s12', styles.buttonContainer)}>
              <Button label="CONTINUE" raised className={styles.continue} onClick={() => this.goToNextTab()} />
            </div>
          </div>,
        )}
      </div>

    );
  }
}

export default PersonalInfo;



// WEBPACK FOOTER //
// ./src/components/PersonalInfo/PersonalInfo.js